
import {
  Component,
  Mixins,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { ITABLECOLCONF } from '@/types/base.d';
import { IContract } from '@/types/org.d';
import api from '@/api/org';
import pageMixin from '@/views/Home/mixins/pageMixin';
import contarctModal from '../form/contract/index.vue';
import uploadModal from '../form/upload/index.vue';

type Visible<T> = {
  contarct: T,
  upload: T,
}

@Component({
  components: {
    Pagination,
    contarctModal,
    uploadModal,
  },
})
export default class Account extends Mixins(pageMixin) {
  @State(state => state.org.curCompRefresh) curCompRefresh!: boolean;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleCloseRerfesh!: Function;

  private loading: Boolean = true;

  private tList: any = [];

  private orgId: string = '';

  private title: string = '';

  private visible: Visible<boolean> = {
    contarct: false,
    upload: false,
  };

  private form: IContract = {
    orgPid: '',
    startTime: '',
    endTime: '',
    pid: '',
    remark: '',
  };

  private row:any = [];

  @Prop({
    required: true,
  }) chargeType!: string;

  private column: Array<ITABLECOLCONF> = [
    {
      label: '合同开始时间',
      custom: true,
      align: 'center',
      tag: {
        type: 'primary',
        prop: ['startTime'],
      },
    },
    {
      label: '合同结束时间',
      custom: true,
      align: 'center',
      tag: {
        type: 'warning',
        prop: ['endTime'],
      },
    },
    {
      label: '状态',
      custom: true,
      prop: 'status',
      align: 'center',
      width: '120px',
      tags: [{
        value: '2',
        type: 'warning',
        label: '已停用',
      }, {
        value: '1',
        type: 'success',
        label: '已启用',
      }, {
        value: '3',
        type: 'danger',
        label: '已过期',
      }, {
        value: '4',
        type: 'danger',
        label: '已作废',
      }],
    },
    {
      label: '更新时间',
      custom: true,
      width: '160px',
      align: 'center',
      tag: {
        type: 'primary',
        prop: ['updateTime'],
      },
    },
    {
      label: '备注',
      prop: 'remark',
      align: 'center',
      tooltip: true,
    },
    {
      label: '操作',
      custom: true,
      minWidth: '80',
      align: 'center',
      maxBtn: 1,
      btnList: [
        {
          title: '编辑',
          name: '/org/operate/contract:update',
          icon: 'edit',
          type: 'info',
          callback: this.handleContarct,
          log: {
            name: '机构信息 - 合同记录 - 编辑',
            component: 'org/operate/table/constract',
          },
        },
        {
          title: '停用',
          name: '/org/operate/contract:status',
          icon: 'shield',
          type: 'info',
          handleType: (row: any) => {
            switch (row.status) {
              case 1: return 'success';
              case 2: return 'warning';
              case 3: return 'danger';
              case 4: return 'danger';
              default: return 'danger';
            }
          },
          handleTitle: (row: any) => {
            switch (row.status) {
              case 1: return '停用';
              case 2: return '启用';
              case 3: return '过期';
              default: return '启用';
            }
          },
          handleDis: (row: any) => {
            if (row.status === 1 || row.status === 2) return false;
            return true;
          },
          callback: this.handleStatus,
          log: {
            name: '机构信息 - 合同记录 - 启用/停用',
            component: 'org/operate/table/constract',
          },
        },
        {
          title: '作废',
          name: '/org/operate/contract:disc',
          icon: 'trash',
          type: 'danger',
          handleDis: (row: any) => {
            if (row.status === 1 || row.status === 4) return true;
            return false;
          },
          callback: this.handlecancel,
          log: {
            name: '机构信息 - 合同记录 - 作废',
            component: 'org/operate/table/constract',
          },
        },
        {
          title: '附件',
          name: '/org/operate/contract:attachment',
          icon: 'paperclip',
          type: 'info',
          callback: this.handleUpload,
          log: {
            name: '机构信息 - 合同记录 - 附件',
            component: 'org/operate/table/constract',
          },
        },
      ],
    },
  ];

  mounted() {
    this.getData();
  }

  /**
   * @author liangyongmou
   * @desc 打开合同模态框
   * @param { any } row 行数据
   */
  handleContarct(row: any) {
    this.form = {
      startTime: row.startTime,
      endTime: row.endTime,
      orgPid: this.orgId,
      pid: row.pid,
      remark: row.remark,
    };
    this.title = '编辑合同';
    this.visible.contarct = true;
  }

  /**
   * @author liangyongmou
   * @desc 打开合同模态框
   * @param { any } row 行数据
   */
  handleUpload(row: any) {
    this.visible.upload = true;
    this.row = row;
  }

  /**
   * @author liangyongmou
   * @desc 获取合同数据
   */
  getData() {
    this.loading = true;
    api.getOrgContractList(this.page, this.$route.params.pid || '').then((res: any) => {
      this.tList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liangyongmou
   * @desc 合同状态改变事件
   * @param { any } row 行数据
   */
  handleStatus(row: any) {
    let status = 1;
    if (row.status === 1) status = 2;
    else if (row.status === 2) status = 1;
    this.contractStatus(row, status);
  }

  /**
   * @author liangyongmou
   * @desc 合同作废
   * @param { any } row 行数据
   */
  handlecancel(row: any) {
    this.contractStatus(row, 4);
  }

  /**
   * @author liangyongmou
   * @desc 合同状态改变事件
   * @param { amy } row 行数据
   * @param { number } status 状态值
   */
  contractStatus(row: any, status: number) {
    this.confirm('你确认进行该操作吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.contractStatus({
        orgId: this.$route.params.pid,
        pid: Base64.encode(row.pid),
        status,
      }).then(() => {
        close();
        this.getData();
        this.$log({
          title: '机构管理 - 启用/停用合同 - 确定',
          component: 'org/manage/contarct',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '机构管理 - 启用/停用合同 - 取消',
      component: 'org/manage/contarct',
    }));
  }

  @Watch('curCompRefresh')
  handlePageRefrsh(v: boolean) {
    if (v) {
      this.handleCloseRerfesh(false);
      this.page.pageNo = 1;
      this.getData();
    }
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
